<ion-header mode="ios">
  <ion-toolbar>
    <super-back-button slot="start" [modalController]="modalController"></super-back-button>
    <ion-title>qid</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  @if(!share){
  <div class="flex justify-center items-center h-full w-full">
    <ion-spinner name="crescent"></ion-spinner>
  </div>
  }

  @if (share) {
  <div sxPadding="medium" sxCol sxGap="10px">


    <div sxRow sxAlign="center" sxDistribution="spaceBetween" sxPadding="medium" sxGap="10px">
      <div sxCol sxGap="10px">
        @if (share.template) {
        <h2 sxMargin="0" sxTextSize="medium">{{ share.template?.purpose}}</h2>
        }
        <p sxMargin="0">{{ share.createTime | date : 'MMM d, y h:mm a' }}</p>

      </div>

      @if (share.status) {
      <div sxTextSize="40px">
        @if (share.status == 'open') {
        <div sxCenterize="col">
          <ion-icon sxColor="warning" name="alert-circle"></ion-icon>
          <p sxMargin="2px 0" sxTextSize="small">Pending</p>
        </div>
        }
        @if (share.status == 'completed') {
        <ion-icon sxColor="success" name="checkmark-circle"></ion-icon>
        }
        @if (share.status == 'cancelled') {
        <div sxCenterize="col">
          <ion-icon sxColor="danger" name="close-circle"></ion-icon>
          <p sxMargin="2px 0" sxTextSize="small">Cancelled</p>
        </div>
        }
      </div>
      }

      @if (!share.status) {
      <ion-icon sxTextSize="40px" sxColor="success" name="checkmark-circle"></ion-icon>
      }

    </div>

    <div sxRow sxGap="10px" sxPadding="15px 22px" sxAlign="center" sxDistribution="spaceBetween" sxRadius="medium"
      sxBackground="base-shade" sxMargin="0 0 15px 0">
      <div sxRow sxGap="10px" sxAlign="center">
        <avatar-round [size]="40" [imageUrl]="organiser?.account?.displayPictureUrl"
          [title]="organiser?.account?.name"></avatar-round>
        <p sxMargin="0">
          {{ organiser?.account?.name }}
        </p>
      </div>
      <p sxColor="two" sxTextSize="small" sxMargin=" 0">Organiser</p>
    </div>

    @if (share?.template?.type == 'check-in') {
    <share-checkin-view [(share)]="share"></share-checkin-view>
    }

    <div sxGap="10px" sxCol>

      @for (participant of sharerParticipants; track participant) {

      @if (participant) {
      <div sxBackground="light" sxRadius="medium" sxPadding="medium 0">

        <div sxRow sxGap="10px" sxPadding="10px 22px" sxAlign="center" sxDistribution="spaceBetween">
          <div sxRow sxGap="10px" sxAlign="center">
            <avatar-round [size]="40" [imageUrl]="participant.account?.displayPictureUrl"
              [title]="participant.account?.name"></avatar-round>

            <div sxCol sxGap="5px">
              <p sxMargin="0" sxCapitalize>
                {{ participant.account?.name?.toLowerCase() }}
              </p>
              @if (participant.account?.averageRating) {
              <div sxRow sxAlign="center" sxGap="5px" sxCursor="pointer"
                (click)="openViewRatingModal(participant.account)"
                [sxColor]="participant.account?.averageRating < 3 ? 'danger' : 'two'">
                <ion-icon name="star-outline"></ion-icon>
                <p sxTextSize="small" sxTextStyle="underline" sxMargin="0">
                  {{participant.account?.averageRating?.toFixed(1)}}</p>
              </div>
              }
            </div>



          </div>
          <p sxColor="two" sxMargin="0" sxTextSize="small" class="font-bold underline cursor-pointer"
            (click)="openParticipantActions(participant)">
            {{getParticipantRole(participant.roles)}}
          </p>
        </div>

        @if (participant.sharedDocumentsIds) {
        <div>
          <swiper-container navigation="true">
            @for (sharedDocumentId of participant.sharedDocumentsIds; track sharedDocumentId) {
            <swiper-slide sxPadding="medium 22px">
              <id-card [documentId]="sharedDocumentId" (viewIdModel)="openViewIdPage($event)"></id-card>
            </swiper-slide>
            }
          </swiper-container>

          @if (participant.sharedDocumentsIds.length > 1) {
          <div sxPadding="0 20px 10px">
            <div sxRow sxRadius="8px" sxBackground="base" sxPadding="10px" sxDistribution="spaceBetween"
              sxTextSize="small">
              <p sxMargin="0" sxColor="two">{{ participant.sharedDocumentsIds.length }} Documents</p>
              <p sxMargin="0" (click)="openViewAllDocumentsPage(participant.sharedDocumentsIds)" sxCursor="pointer">
                View All</p>
            </div>
          </div>
          }
        </div>
        }

        @if (!participant.sharedDocumentsIds) {
        <div sxPadding="medium">
          <div sxCenterize="row" sxBackground="one" sxRadius="medium" sxHeight="160px">
            <p sxColor="two">No document shared yet</p>
          </div>
        </div>
        }

        @if (participant?.accountSnapshot?.phoneNumber) {
        <ion-item>
          <ion-input labelPlacement="stacked" label="Phone" readonly=""
            value="{{ participant?.accountSnapshot?.phoneNumber | formatPhone }}"></ion-input>
          <ion-icon name="logo-whatsapp" slot="end" sxTextSize="24px" sxCursor="pointer" sxColor="#25D366"
            (click)="openWhatsapp(participant?.accountSnapshot)"></ion-icon>
        </ion-item>
        }
        <ion-item>
          <ion-input labelPlacement="stacked" label="Email" readonly=""
            value="{{ participant?.accountSnapshot?.email || participant?.email || '-' }}"></ion-input>
        </ion-item>

        @for (info of participant.otherFields; track info) {
        <ion-item>
          <ion-input labelPlacement="stacked" label="{{info.label}}" readonly="true"
            value="{{ info.value ? info.value : '-' }}"></ion-input>
        </ion-item>
        }

        <div sxPadding="medium">
          @if (participant.facePhoto) {
          <div sxRow sxPadding="medium" sxBorderWidth="1px" sxBorderColor="one" sxRadius="medium" sxAlign="center"
            sxGap="10px" sxCursor="pointer" (click)="onSelfieClicked(participant.facePhoto.imageUrl)">
            <avatar-round [size]="50" [imageUrl]="participant.facePhoto.imageUrl"></avatar-round>
            <p sxWidth="fill">Selfie Verification</p>
            @if (participant.facePhoto.isLive) {
            <div sxRow sxAlign="center" sxGap="5px">
              <ion-icon name="shield-checkmark-outline"></ion-icon>
              <p sxColor="two" sxTextSize="small">Liveness</p>
            </div>
            }
          </div>
          }
        </div>

        @if (participant.signatureImageUrl) {
        <div sxBackground="light" sxPadding="medium" sxRadius="medium" sxRow sxAlign="center">
          <img alt="signature" sxWidth="100px" sxHeight="50px" [src]="getImage(participant?.signatureImageUrl)" />
          <p sxMargin="0" sxTextSize="small" sxWidth="fill">
            <b>I {{ participant?.account?.name }},</b> confirm that the provided Documents and
            information are true and accurate to the best of my
            knowledge.
          </p>
        </div>
        }

      </div>
      }


      }

      @if (share.otherFields.length>0) {
      <div class="flex flex-col border border-ocean-300 rounded-md">
        @for (info of share.otherFields; track info) {
        @if (!info.sectionBreak && !info.isForEachParticipant) {

        <div class="flex flex-col justify-between items-start border-b border-ocean-300  last:border-b-0 p-4">
          <p class="text-sm text-gray-600">{{info.label ? info.label : info?.name}}</p>
          <p class="text-base text-gray-800">{{info.value ? info.value : '-'}}</p>
        </div>
        }
        @if (info.sectionBreak) {
        <div sxCol sxGap="5px" sxPadding="25px 10px 10px">
          <h1 sxMargin="0" sxTextSize="large">{{info.sectionBreak?.title}}</h1>
          @if (info?.sectionBreak?.description; as description) {
          <p sxMargin="0" sxTextSize="small" sxColor="two">
            {{description}}</p>
          }
        </div>
        }
        }
      </div>
      }
    </div>

    @if (share.webhookIdentifier) {
    <div class="group flex items-center justify-between gap-3 border border-ocean-300 rounded-md cursor-pointer p-4"
      (click)="copyToClipboard(share.webhookIdentifier)">
      <div class="flex flex-col min-w-0">
        <p class="text-sm text-gray-600 m-0">Identifier</p>
        <p class="text-base text-gray-800 break-all m-0">{{ share.webhookIdentifier }}</p>
      </div>
      <ion-icon name="copy-outline" class="shrink-0 opacity-0 group-hover:opacity-100 transition-opacity"
        sxTextSize="18px" sxColor="two"></ion-icon>
    </div>
    }

    @if (share.status == 'completed' && share.agreements.length>0) {
    <div sxCol sxGap="10px">
      <h2 sxRow sxAlign="center" sxGap="3px" sxMargin='medium 0 0 medium' sxTextSize='16px' sxColor='two'>
        <ion-icon name="checkmark-circle"></ion-icon>
        Policies Accepted
      </h2>
      <div sxRadius="medium" sxBackground="light" sxMargin="0">
        @for (agreement of share.agreements; track agreement) {
        <ion-accordion-group sxWidth="fill" sxCursor="pointer" sxBorderColor="one" sxBorderWidth="0 0 1px">
          <ion-accordion>
            <ion-item slot="header">
              <ion-icon name="document-text-outline"></ion-icon>
              <ion-label>{{agreement.title}}</ion-label>
            </ion-item>
            <div slot="content">
              <app-agreement-view [agreement]="agreement" [viewOnly]="true"></app-agreement-view>
            </div>
          </ion-accordion>
        </ion-accordion-group>
        }
      </div>
    </div>
    }

    <div sxWidth="full" sxHeight="20px"></div>

    <super-button (click)="onWriteAReviewClicked()" iconStart="create-outline" background="base-shade" color="dark"
      textAlign="start" hideForPlatform="native" size="small">Write a Review</super-button>

    <super-button [action]="printAsPDF" iconStart="print-outline" background="base-shade" color="dark" textAlign="start"
      hideForPlatform="native" size="small">Print or Save
    </super-button>

    <div visibleTo="org" [minimumRole]="1">
      <super-button [permissionModule]="ApiModules.Share" [permissionOperation]="ApiOperations.delete" #deleteLoader
        type="wrap" [isDefaultLoader]="false" [action]="deleteShare" iconStart="trash-outline" background="base-shade"
        size="small" color="dark" textAlign="start">Delete
      </super-button>
    </div>


  </div>
  }
  @if (logsWithRemarks.length > 0) {
  <div sxPadding="medium" sxBorderColor="one" sxBorderWidth="5px 0 0 0" sxMargin="20px 0">

    <p sxMargin="20px 10px 5px" sxTextWeight="bold">Logs</p>

    @for (log of logsWithRemarks; track $index; let i = $index) {
    <div class="flex flex-row items-center justify-start gap-4 ps-4 h-[60px]">

      <div class="flex flex-col items-center justify-center h-full">
        <div class="flex flex-col w-[1px] h-full flex-1 bg-ocean-300"></div>
        <div class="flex flex-col items-center justify-center w-[20px] h-[20px] rounded-full bg-ocean-300">
          <div sxCircle="12px" sxBackground="two" sxCol></div>
        </div>
        <div class="flex flex-col w-[1px] h-full flex-1 bg-ocean-300"
          [class.bg-transparent]="i == (logsWithRemarks.length - 1)"></div>
      </div>

      <div class="flex flex-col items-start justify-between">
        <p sxMargin="0" sxTextSize="small">{{log.remark}}</p>
        <p sxMargin="0" sxTextSize="10px" sxColor="two">
          <span sxTextStyle="underline">By {{log?.updatedByAccountSnapshot?.name}}</span>
          | {{log.updateTime | date : 'medium'}}
        </p>
      </div>
    </div>
    }

    <div class="flex justify-start items-center pt-6 px-4">
      <p class="text-center text-sm text-gray-500">ID: {{share?._id}}</p>
    </div>


  </div>
  }



  <div sxHeight="100px" sxCenterize="row" sxBorderColor="one" sxBorderWidth="5px 0 0">
    <p sxColor="two" sxTextSize="small">oneqid.com</p>
  </div>

</ion-content>